import { Component, OnInit } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { Constants } from '@app/shared-module/constants';
import { MatDialogRef } from '@angular/material';
import { AdminService } from '@app/services/admin.service';

@Component({
  selector: 'app-changepassword',
  templateUrl: './changepassword.component.html',
  styleUrls: ['./changepassword.component.css']
})
export class ChangepasswordComponent implements OnInit {

  @BlockUI() blockUI: NgBlockUI;
  isLoggedIn = true;
  oldPassword = '';
  newPassword = '';
  confirmPassword = '';
  showOldPassword = false;
  showNewPassword = false;
  shownConfirmPassword = false;
  userID: string;

  constructor(
    public dialogRef: MatDialogRef<ChangepasswordComponent>,
    private service: AdminService,
    private toastr: ToastrService) { }

  ngOnInit() {
  }


  changePassword = () => {
    this.dialogRef.close(true);
    if (this.oldPassword.length > 6 && this.newPassword.length > 6 && this.confirmPassword.length > 6) {
      if (this.newPassword === this.confirmPassword) {
        this.blockUI.start('Updating...');
        this.service.changePassword(this.userID, this.oldPassword, this.newPassword).subscribe(res => {
          if (res) {
            // console.log(res);
            this.dialogRef.close(true);
          }
        }, error => {
          setTimeout(() => {
            this.blockUI.stop();
          }, 200);
          this.toastr.error(Constants.LABEL_ERROR, 'Password reset failed');
        });
      } else {
        this.toastr.error(Constants.LABEL_ERROR, 'Confirm Password doesnot match with New Password');
      }
    } else {
      this.toastr.error(Constants.LABEL_ERROR, 'Password length must be greater than 6 characters');
    }
  }

}
